/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description: 内容反馈组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-08-29 19:39:31
 */
import React from 'react'
import './ContentFeedback.css'

import { useSensorTracking } from '../hooks/useSensorTracking'
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons'

interface ContentFeedbackProps {
  visible: boolean
  fieldName: string
  onFeedbackClick?: (actionType: string) => void // 反馈点击回调
}

/**
 * 内容反馈组件
 * 在内容下方显示"准确"和"不准"反馈按钮
 */
const ContentFeedback: React.FC<ContentFeedbackProps> = ({
  visible,
  fieldName,
  onFeedbackClick
}) => {
  const { reportAISecurityPageActionClick } = useSensorTracking()

  // 仅在记录状态为已完成时显示
  if (!visible) {
    return null
  }

  /**
   * 处理准确反馈点击
   */
  function handleAccurateFeedback() {
    reportAISecurityPageActionClick({
      actionType: 'feedbackPositive',
      bool1: true,
      string1: fieldName
    })

    onFeedbackClick && onFeedbackClick('feedbackPositive')
  }

  /**
   * 处理不准确反馈点击
   */
  function handleInaccurateFeedback() {
    reportAISecurityPageActionClick({
      actionType: 'feedback',
      bool1: false,
      string1: fieldName
    })

    onFeedbackClick && onFeedbackClick('feedback')
  }

  return (
    <div className="content-feedback">
      <button
        className="feedback-button accurate"
        onClick={(e) => {
          e.stopPropagation()
          handleAccurateFeedback()
        }}
      >
        <LikeOutlined style={{ fontSize: '12px' }} />
        准确
      </button>
      <button
        className="feedback-button inaccurate"
        onClick={(e) => {
          e.stopPropagation()
          handleInaccurateFeedback()
        }}
      >
        <DislikeOutlined style={{ fontSize: '12px' }} />
        不准
      </button>
    </div>
  )
}

export default ContentFeedback
